<template>
    <div class="px-6 pb-3 border-b border-a-gray-d0d0ce">
        <div class="font-medium text-16 text-a-gray-555555">{{campaign.name}}</div>
        <div class="flex pt-6">
            <div class="flex pt-1 w-full">
                <div class="font-light text-12 text-a-black-484848 mt-auto">{{FilterStringFormat(lbl.detail.expire_date)}}</div>
                <div class="font-medium text-12 text-a-black-484848 pl-1 mt-auto">{{FilterDateFormat(campaign.expireDate)}}</div>
            </div>
            <div class=" w-full campaing-qty">
                <div class="font-medium text-12 text-a-black-484848 text-center pb-2">{{lbl.detail.campaign_qty}}</div>
                <div class="w-full bg-a-gray-d0d0ce rounded-full h-1.5">
                    <div class="bg-a-orange-fe5000 h-1.5 rounded-full" :style="{width: `${percentage}`}"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailInfo",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            percentage: '',
        }
    },
    created: function() {
        this.percentage = this.campaignPercentage();
    },
    methods: {
        getPointTxt: function () {
            let pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            let pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        agencyLogoUrl: function() {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
        campaignPercentage: function(){
            let Quantity = this.campaign.quantity
            let Qty = this.campaign.qty
            let result = (Qty * 100) / Quantity
            return result + "%"
        }
    },
}
</script>
<style lang="scss" scoped>
    .campaing-qty {
        max-width: 125px;
    }
</style>
